const EbikeIcon = () => {
  return (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M12.4585 6.45703L10.6484 8.66081"
        stroke="black"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.45006 22.4176C9.15544 24.1554 7.64286 25.4788 5.82126 25.4788C3.78856 25.4788 2.14062 23.8308 2.14062 21.7981C2.14062 19.7651 3.78856 18.1172 5.82126 18.1172"
        stroke="black"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M27.8901 18.7031C28.695 19.2181 29.3001 20.0441 29.5101 21.0535C29.9242 23.0436 28.6467 24.993 26.6566 25.4072C24.8361 25.7862 23.0497 24.7494 22.4414 23.0462"
        stroke="black"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19.3456 15.1772L17.0877 15.4163C16.7179 15.4506 16.4132 15.1378 16.4509 14.7683C16.5114 14.1753 16.7522 13.0544 17.7184 12.9743C19.3917 12.8355 25.2176 12.4375 25.2176 12.4375C25.7548 12.4375 26.1208 12.7318 26.2893 13.2119"
        stroke="black"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M28.1677 12.9739L27.2957 13.8679C27.0431 14.1271 26.7096 14.2915 26.3501 14.3345L21.6385 14.8894C20.9337 14.9758 20.8663 15.6515 20.9746 15.9064L21.8141 17.8302C22.0304 18.3106 22.0183 18.5977 21.813 18.8486C21.5702 19.1446 21.1333 19.6463 20.7863 19.9911C20.193 20.5806 19.3028 20.6895 18.9543 20.6895C17.777 20.6895 13.4861 20.8821 13.4861 20.8821C12.9368 20.9078 12.4239 20.6074 12.178 20.1155L11.0254 17.5048C10.6919 16.838 10.5441 16.2281 10.7915 15.5248L11.9389 12.381C12.0463 12.0757 11.9386 11.7358 11.6748 11.5483L11.3566 11.3223"
        stroke="black"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.1693 19.5393L17.1086 16.5156"
        stroke="black"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.7937 21.7868L7.40765 19.293"
        stroke="black"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.8292 7.76172L13.3274 8.08284C13.6223 8.27321 13.6906 8.67583 13.4746 8.9526L12.8096 9.80479C12.6175 10.0507 12.2768 10.1236 12.0012 9.9773L11.8408 9.89205C11.4793 9.70053 11.0329 9.78722 10.7697 10.1006L7.03405 14.5513C6.59716 15.0714 6.56461 15.82 6.95485 16.3758L9.76141 21.1871C10.3584 22.0373 11.3319 22.543 12.3707 22.543H19.2087C19.9278 22.543 20.6259 22.3 21.1895 21.8536L27.1425 17.1378C27.7029 16.6938 27.7738 15.949 27.4821 15.2889"
        stroke="black"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M27.3293 21.6926C27.4309 22.442 26.9062 23.1315 26.1571 23.2334C25.408 23.3348 24.7183 22.8101 24.6166 22.0607C24.5149 21.3119 25.0397 20.6221 25.7888 20.5205C26.5379 20.4185 27.2276 20.9433 27.3293 21.6926Z"
        stroke="black"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export default EbikeIcon
